export default __webpack_public_path__ + "static/media/Schoolhouse-Logo-Horizontal-Md.99403cc8.png";